<template>
    <div>
        <el-upload
        class="cloud-upload"
        action=""
        :accept="config.accept"
        :http-request="fileUpload"
        :show-file-list="false"
        :multiple="config.multiple">
        <slot name="choose"></slot>
        
        </el-upload>
        
    </div>
</template>

<script>
import axios from 'axios'
import md5 from 'js-md5'
export default {
    name: 'xes-cloud-upload',
    props: {
        mustkey:{
            type:String,
            required:true
        },
        appid:{
            type:String,
            required:true
        },
        dst_path:{
            type:String,
            required:true
        },
        config:{
           type:Object,
           default(){
               return {
                    acceptMsg:"",
                    windowsAccept:[],
                    accept:'',
                    nameLen:'120',
                    fileSize:50,
                    multiple:false
               }
           }
        },
        progress:{
            type:Function,
            default(){
                return function progress (){

                }
            }
        }
    },
    data() {
        let Base64 = require('js-base64').Base64;
        return {
            // currentFile:{}
        }
    },
    methods: {
        fileUpload({file}){
            console.log(this.config)
            // return;
            if (file.name.length > this.config.nameLen) {
                this.$message({
                    message: `文件名长度不能超过${this.config.nameLen}个字`,
                    center: true,
                    type: 'error'
                })
                return
            }
            if (file.size > (1024 * 1024 * this.config.fileSize)) {
                this.$message({
                    message: `文件大小不能大于${this.config.fileSize}M`,
                    center: true,
                    type: 'error'
                })
                return
            }
            let arr=this.config.windowsAccept
            if(arr.length!=0){
                let ext = file.name.split(".");
                ext = ext[ext.length - 1].toLowerCase();
                if (
                    !arr.includes(ext)
                ) {
                    let msg = this.config.acceptMsg
                    this.$message.warning("只能上传"+msg+"文件");
                    return
                }
            }
            let picname = file.name.substring(0,file.name.lastIndexOf('.'))
            let pictype = file.name.substring(file.name.lastIndexOf('.')+1)
            
            //阿里云上传
            // 将key值转化为sign
            let key = this.mustkey // 密钥串
            // let key = 'a011d73d948785243effa91b4430484f'  // 密钥串
            let time = Date.parse(new Date()) // 获取当前时间戳
            var newFileName = md5(time + '-'+file.name)+'.'+pictype
            let keyMd5 = md5(key + '&' + time) // 生成加密串
            let sign = Base64.encode(keyMd5 + '&' + time) // 生成sign
            // 自动上传图片
            //不携带cookie
            axios.defaults.withCredentials = false
            axios.defaults.timeout = 9000000
            axios.get('https://upload.xueersi.com/v2/upload_param', {
                params:{
                    dst_path: this.dst_path+newFileName, // 文件在云端的存储位置
                    user_mark: 0,
                    file_right: 0, // 文件的属性，0指公有读，1指私有读
                },
                headers: {
                    appid: this.appid, // 网关申请到的appid
                    sign: sign // 验证签名，访问upload应用的凭证
                }
            }).then(res => {
                // this.is_success = true
                this.$emit('isuploading',true)
                res.data.data.forEach(ele => {
                    if(ele.type=='OSS'){
                        // this.currentFile = {ele:ele,file:file};
                        let CancelToken = axios.CancelToken;
                        let source = CancelToken.source();
                        this.$emit('cloudparameter',{ele:ele,file:file,cencal:source})
                        this.fileUploadCloud({ele:ele,file:file,cantoken:source.token})
                    }
                });
                
            }).catch(err => {
                this.$message.error('文件名有特殊字符 上传失败')
                console.log(err)
                this.$emit('isuploading',false)
                // this.is_success = false
            })
        },
        fileUploadCloud(data){
            if(Object.keys(data).length==0){
                this.$message.error('请选择资源')
                return;
            }
            axios.put(data.ele.host, data.file, {
                cancelToken: data.cantoken?data.cantoken:'',
                headers: data.ele.request_header,
                onUploadProgress: this.progress
            }).then(res => {
                this.$emit('result',{code:100,url:data.ele.file_url})
                this.$emit('isuploading',false)
            }).catch(err => {
                this.$emit('result',{code:0})
                this.$emit('isuploading',false)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// packages/cloudUpload/src/index.vue